import React from 'react';

const InfoItem = ({ label, value, className }) => (
  <div className={`info-item${className ? ` ${className}` : ''}`}>
    <span className="info-label">{label}:</span>
    <span className="info-value">{value ?? 'N/A'}</span>
  </div>
);

export default InfoItem;

